import React from 'react'
import * as PropTypes from 'prop-types'
import { NavFooter } from './navFooter'
import { Participants } from './participants'
import { createPortal } from 'react-dom'
import { EventGroup } from '../../../datastores/eventGroup'
import { ValidateAddParticipantController } from '../../../datastores/validateAddParticipantController'
import { observer } from 'mobx-react-lite'
import { RootStore } from '../../../datastores/rootStore'
import Translator from '../../translator'
import { StepController } from '../../../datastores/stepController'
import GA4Tracking from '../../../utils/ga4-tracking'

export const EditParticipantsDialogAll = observer(
  function EditParticipantsDialogAll(props) {
    let validateAddParticipantController =
      ValidateAddParticipantController.getInstance()

    return props.open
      ? createPortal(
          <div
            className={'mtt-modal mtt-modal--visible mtt-modal--participants'}
          >
            <div className={'mtt-modal__overlay'}>
              <div
                className={'mtt-modal__container'}
                onClick={e => {
                  e.stopPropagation()
                }}
              >
                <button
                  className={'mtt-modal__close'}
                  onClick={() => {
                    props.onClose()
                  }}
                  disabled={validateAddParticipantController.loading}
                />
                <div className={'participants-modal-header'}>
                  <div className='participants-modal-header__text'>
                    <div className='participants-modal-header__tagline'></div>
                    <div className='participants-modal-header__title'>
                      {Translator.translate(
                        'Tilføj samme deltagere til alle arrangementer',
                        'cart'
                      )}
                    </div>
                    <div className='participants-modal-header__subtitle'></div>
                  </div>
                </div>
                <Participants
                  p={props.p}
                  eventGroups={props.eventGroups}
                  displayExisting={false}
                />
                <div className={'errors'}>
                  {Object.values(
                    validateAddParticipantController.errors?.groupErrors ?? {}
                  )
                    .flatMap(x => Object.entries(x ?? {}))
                    .map(([index, error]) => {
                      return <div key={index}>{error}</div>
                    })}
                </div>
                <NavFooter
                  onBack={() => {
                    props.onClose()
                  }}
                  loading={validateAddParticipantController.loading}
                  backDisabled={validateAddParticipantController.loading}
                  saveDisabled={
                    validateAddParticipantController.loading ||
                    !validateAddParticipantController.isAllValid
                  }
                  onSubmit={async () => {
                    let oldParticipantsCount = {}
                    for (let i = 0; i < props.eventGroups.length; i++) {
                      oldParticipantsCount[props.eventGroups[i].id] = Object.keys(props.eventGroups[i].participants).length
                    }

                    await validateAddParticipantController.validate(
                      props.eventGroups,
                      props.p.ps,
                      RootStore.getInstance().cart.customer,
                      RootStore.getInstance().cart.coupon,
                      true
                    )
                    if (validateAddParticipantController.isAllValid) {
                      props.eventGroups.forEach(eventGroup => {
                        StepController.getInstance().validationResults.delete(`eventGroups.${eventGroup.id}`)
                      })
                      props.p.submitToAll(props.eventGroups)
                      let cart = RootStore.getInstance().cart
                      cart.updateContent(
                        validateAddParticipantController.validation_data
                      )

                      props.eventGroups.forEach(eventGroup => {
                        let newParticipantsCount = Object.keys(eventGroup.participants).length
                        newParticipantsCount = oldParticipantsCount[eventGroup.id] === 0 ? newParticipantsCount - 1 : newParticipantsCount
                        let items = GA4Tracking.getItemsAndAddonsFromCartEventGroups([eventGroup])
                        GA4Tracking.handleUpdateOfProductsInCart(items, oldParticipantsCount[eventGroup.id], newParticipantsCount)
                      })

                      props.onClose()
                    }
                  }}
                />
              </div>
            </div>
          </div>,
          document.body
        )
      : null
  }
)
EditParticipantsDialogAll.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  p: PropTypes.any,
  eventGroups: PropTypes.arrayOf(PropTypes.instanceOf(EventGroup)).isRequired
}
